import { HudlDataSchemas } from '@hudl/analytics';
import { KeysToCamelCase } from '@statsbomb/parachute-types';
import { UserConfigType } from '@/types/userConfigs';

// The values the view can be configured to
export enum ViewConfiguration {
  NEW = 'new',
  CLASSIC = 'classic',
}

// The view that was changed
export enum ViewType {
  PLAYER = 'player',
  TEAM = 'team',
  PLAYER_SCOUT = 'player_scout',
}

// The sub view that was changed
export enum ViewSubType {
  DASHBOARD = 'dashboard',
}

// The method which was used to change the configuration, i.e 'setting page', 'sidenav' etc.
export enum ViewConfigurationSource {
  SIDE_NAVIGATION = 'side navigation',
  PLAYER_DASHBOARD_BUTTON = 'player dashboard button',
  PLAYER_SCOUT = 'player scout page',
  EXPLORE_LANDING_PAGE = 'explore landing page',
  TEAM_DASHBOARD_BUTTON = 'team dashboard button',
}

export const configTypeContextMap: Partial<Record<UserConfigType, string>> = {
  radarTemplate: 'Custom Radar',
  filters: 'Filter Set',
};

export enum ObjectConfigurationObjectType {
  Visualisation = 'visualisation',
}

export enum ObjectConfigurationObjectSubType {
  Radar = 'radar',
  Table = 'table',
}

export enum ObjectConfigurationConfigurationType {
  DataFormat = 'data_format',
  MetricDisplayFormat = 'metric_display_format',
  SecondaryDataFormat = 'secondary_data_format',
}

export type ObjectConfigurationEventParams = Omit<
  KeysToCamelCase<HudlDataSchemas.ObjectConfigurationEvent.V1_0_0.Data>,
  'objectType' | 'objectSubType' | 'configurationType' | 'configurationSource'
> & {
  objectType: ObjectConfigurationObjectType;
  objectSubType: ObjectConfigurationObjectSubType;
  configurationType: ObjectConfigurationConfigurationType;
  configurationSource?: string;
};
